import { getField, updateField } from "vuex-map-fields";
import router from "../../../router";

// const timerSeconds = 300;
// let tid = new Object();

const getDefaultState = () => {
  return {
    Toast: {
      isOpen: false,
      contents: "",
    },
    Modal: {
      isOpen: false,
      contents: "",
    },
    SSInfogetMotp: {
      in: {},
      out: [
        // {
        // 	strUserId: "G21000009100000"
        // , secret: "dfefewfsdfadsafasdfasdfsdf...."
        // }
      ],
    },
    /**
     * 초기화 init
     */
    initMotp: {
      in: {},
      out: {
        success: {
          mOtpId: "",
          systemId: "",
          wwwBnkgLginID: "",
          otpStusDstcd: "",
          issuncYMS: "",
          SmphMchtlUniqNo: "",
          lastCertnSucssYMS: "",
          totalCertnErrNotms: "",
          certnErrNotms: "",
        },
        fail: {},
      },
    },
    MotpisIssuncYn: "",
    /**
     * mOTP 등록
     */
    SSRegisterMotpPin: {
      in: {
        result: "",
        publickey: "",
        userdata: "",
        errorcode: "",
        smphMchtlUniqNo: "", // 스마트폰기기고유번호
        smphMchtlDstcd: "", // 스마트폰기기구분코드(1:IPhone, 2:안드로이드)
        pgmVsnno: "", // 프로그램버전번호
        smphMdelName: "", // 스마트폰모델명
      },
      out: {
        success: {
          RESULT: "",
          MOTPINFO: "",
          SKEY: "",
          ERRORCODE: "",
        },
        fail: {},
      },
    },
    ////////////////////////////////////////////////
  };
};

const changeMotpPin = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    getToast: state => {
      return state.Toast;
    },
    getSSInfogetMotp: state => {
      return state.SSInfogetMotp;
    },
    getMotpisIssuncYn: state => {
      return state.MotpisIssuncYn;
    },
    getInitMotp: state => {
      return state.initMotp;
    },
    //////////////////////////////////////////////////////////////
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    // mut001: function(state, payload) {
    //   this._vm.$set(state.SSInfogetMotp, "out", payload);
    // },
    mut001: function(state, payload) {
      state.SSInfogetMotp.out = [];
      payload.Motpinfo.length > 0 &&
        payload.Motpinfo.forEach(e => {
          state.SSInfogetMotp.out.push(e);
        });
    },
    mut010: function(state, payload) {
      this._vm.$set(state.Modal, payload.key, payload.value);
    },
    ///////////////////////////////////////////////////////////////
  },
  actions: {
    /**
     * 인증번호오류, DB업데이트
     */
    act010: function() {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/unlockAuthErrMotp/updateMotpPin",
          this.state.auth.unlockAuthErrMotp.SSRegisterMotpPin.in,
          response => {
            this._vm.$set(this.state.auth.unlockAuthErrMotp.SSRegisterMotpPin.out, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(this.state.auth.unlockAuthErrMotp.SSRegisterMotpPin.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },

    /**
     * mOTP 등록 init
     */
    act012: function() {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/unlockAuthErrMotp/initMotp",
          this.state.auth.unlockAuthErrMotp.initMotp.in,
          response => {
            this._vm.$set(this.state.auth.unlockAuthErrMotp.initMotp.out, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(this.state.auth.unlockAuthErrMotp.initMotp.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },

    /**
     * 기기정보 후 처리
     */
    act014: function() {
      // console.log("unlockAuthErrMotp smphMchtlUniqNo---------->" + this.state.native.smphMchtlUniqNo);
      // console.log("unlockAuthErrMotp mOtpId---------->" + this.state.auth.unlockAuthErrMotp.initMotp.out.success.mOtpId);
      // console.log("unlockAuthErrMotp strUserId------>", this.state.auth.unlockAuthErrMotp.SSInfogetMotp.out);
      // console.log("unlockAuthErrMotp otpStusDstcd------>", this.state.auth.unlockAuthErrMotp.initMotp.out.success.otpStusDstcd);
      // console.log("unlockAuthErrMotp systemId------>", this.state.auth.unlockAuthErrMotp.initMotp.out.success.systemId);
      // console.log("unlockAuthErrMotp SmphMchtlUniqNo------>", this.state.auth.unlockAuthErrMotp.initMotp.out.success.SmphMchtlUniqNo);

      // 현재 폰에 정상인 mOTP가 있는 경우. (인증오류해제는 상태가 030 아님 ,예외처리로 인증가능함 )
      if (
        this.state.auth.unlockAuthErrMotp.SSInfogetMotp.out.filter(item => {
          return item.strUserId === this.state.auth.unlockAuthErrMotp.initMotp.out.success.mOtpId;
        }).length > 0 &&
        (this.state.auth.unlockAuthErrMotp.initMotp.out.success.otpStusDstcd === "030" ||
          this.state.auth.unlockAuthErrMotp.initMotp.out.success.otpStusDstcd === "140" ||
          this.state.auth.unlockAuthErrMotp.initMotp.out.success.otpStusDstcd === "150") &&
        this.state.auth.unlockAuthErrMotp.initMotp.out.success.SmphMchtlUniqNo === this.state.native.smphMchtlUniqNo
      ) {
        this.state.auth.unlockAuthErrMotp.MotpisIssuncYn = "Y";
        // console.log("OK---->현재 폰에 정상인 mOTP가 있는 경우 ");
      } else {
        this.state.auth.unlockAuthErrMotp.MotpisIssuncYn = "N";
        // console.log("NO---->현재 폰에 비정상인 mOTP가 있는 경우");
        router.push({ name: "unlockAuthErrMotpStep5" });
      }
    },

    //////////////////////////////////////////////////////////////////
  },
};

export default changeMotpPin;

/**
 	ErrmsgErrcd: "",
	OutptLangDstcd: "",
	CustGuidLinkURL: "",
	ErrmsgErrSituNo: "",
	CustGuidLinkURLCtnt: "",
	ErrmsgTreatCd: "",
	Clear: "",
	ErrmsgErrPgmName: "",
	Type: "",
	TreatDesc: "",
	Trancode: "",
	ErrmsgOutptCstzMsgCtnt: "",
	MapngDstcd: "",
	Subtype: ""
 */
